import { render, staticRenderFns } from "./user_with_access.vue?vue&type=template&id=1fa8ea90&"
import script from "./user_with_access.vue?vue&type=script&lang=js&"
export * from "./user_with_access.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fa8ea90')) {
      api.createRecord('1fa8ea90', component.options)
    } else {
      api.reload('1fa8ea90', component.options)
    }
    module.hot.accept("./user_with_access.vue?vue&type=template&id=1fa8ea90&", function () {
      api.rerender('1fa8ea90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ugsrc/components/apps/user_with_access.vue"
export default component.exports